// #region Imports

/* Telestream */
import { LAYOUT_FLAGS, ACTION_FLAGS, TAB_IDS } from '../../utils/constants';
import { restoreBottomTabs, restoreTopTabs } from './persistence.utils';

// #endregion Imports

export function extractLayoutFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const panesParam = urlParams.get('panes');
  
  const panesValue = panesParam ? parseInt(panesParam, 16) : 0xff;
  const layout = {
    header: {
      visible: panesValue & LAYOUT_FLAGS.HEADER_FLAG
    },
    fileToolbar: {
      visible: panesValue & LAYOUT_FLAGS.FILE_TOOLBAR_FLAG,
      actions: extractVisibleActionsFromQueryParams()
    },
    videoPlayer: {
      visible: panesValue & LAYOUT_FLAGS.VIDEO_PLAYER_FLAG
    },
    timeline: {
      visible: panesValue & LAYOUT_FLAGS.TIMELINE_FLAG
    },
    topTabs: {
      visible: panesValue & LAYOUT_FLAGS.TOP_TABS_FLAG,
      locked:  extractTabsLockedFromQueryParams('top'),
      tabs:    extractTabsFromQueryParams('top')
    },
    bottomTabs: {
      visible: panesValue & LAYOUT_FLAGS.BOTTOM_TABS_FLAG,
      locked:  extractTabsLockedFromQueryParams('bottom'),
      tabs:    extractTabsFromQueryParams('bottom')
    }
  };

  return layout;
}

function extractVisibleActionsFromQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const actionsParam = urlParams.get('actions');

  const actionsValue = actionsParam ? parseInt(actionsParam, 16) : 0xff;
  const visibleActions = {
    watchers: actionsValue & ACTION_FLAGS.WATCHERS_FLAG,
    cliplink: actionsValue & ACTION_FLAGS.CLIP_LINK_FLAG,
    close:    actionsValue & ACTION_FLAGS.CLOSE_FLAG,
    browse:   actionsValue & ACTION_FLAGS.BROWSE_FLAG,
    history:  actionsValue & ACTION_FLAGS.HISTORY_FLAG,
  };

  return visibleActions;
}

function extractTabsLockedFromQueryParams(which) {
  const urlParams = new URLSearchParams(window.location.search);
  const tabsParam = urlParams.get(`${which}Tabs`);

  if (!tabsParam) {
    return false;
  }

  const tabIds = tabsParam.split(',');
  return tabIds.shift() === 'ff';
}

function extractTabsFromQueryParams(which) {
  const urlParams = new URLSearchParams(window.location.search);
  const tabsParam = urlParams.get(`${which}Tabs`);

  if (!tabsParam) {
    if (which === 'top') {
      return restoreTopTabs();
    } else {
      return restoreBottomTabs();
    }
  }

  const tabIds = tabsParam.split(',');
  return tabIds
    .slice(1)            // Remove the locked flag
    .map(hexTabId => {
      const tabId = parseInt(hexTabId, 16);
      return Object.keys(TAB_IDS).find(key => TAB_IDS[key] === tabId);
    });
}
